import React, { useState, useRef } from 'react';
import Form from './Form';
import FormConfirmed from './FormConfirmed';
import CoinTotals from './CoinTotals';
import { Title } from '@gerdau/hefesto';
import { Container } from './styles';
import { ApplicationState } from '../../../../../store';
import { useSelector } from 'react-redux';

export interface RewardBeneficiary {
  rewardType: string;
  companyName: string;
  companyTaxVat: string;
  phone: string;
  rewardValue: string;
  address: string;
  locked: boolean;
}
interface RewardFormProps {
  setSuccess: (isDataConfirmed: boolean) => void;
}

const RewardForm: React.FC<RewardFormProps> = ({ setSuccess }) => {
  const baseBeneficiary: RewardBeneficiary = {
    companyName: '',
    rewardType: '',
    companyTaxVat: '',
    address: '',
    phone: '',
    rewardValue: '',
    locked: false
  };

  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const totalPoints = loyalty.rewards.total.total_coins;
  const campaingPercentage = loyalty.withdraw.body.campaign_card / 100;
  const maxFormValue = loyalty.withdraw.body.cards_limit;
  const generateFirstBeneficiarys = () => {
    const baseBeneficiarys: RewardBeneficiary[] = [];

    const campaingTotalPoints = totalPoints * campaingPercentage;
    const numberOfCampaingCards = Math.ceil(campaingTotalPoints / maxFormValue);
    const campaingRewardValue =
      Math.floor(100 * (campaingTotalPoints / numberOfCampaingCards)) / 100;
    let campaingLeftOver =
      campaingTotalPoints - campaingRewardValue * numberOfCampaingCards;

    const otherRewardPoints = totalPoints - campaingTotalPoints;
    const numberOfOtherRewardsCards = Math.ceil(
      otherRewardPoints / maxFormValue
    );
    const otherRewardsValue =
      Math.floor(100 * (otherRewardPoints / numberOfOtherRewardsCards)) / 100;
    let othersLeftOver =
      otherRewardPoints - otherRewardsValue * numberOfOtherRewardsCards;
    while (
      baseBeneficiarys.length <
      numberOfCampaingCards + numberOfOtherRewardsCards
    ) {
      let value = 0;
      if (baseBeneficiarys.length < numberOfCampaingCards) {
        value = campaingRewardValue;
        if (campaingLeftOver > 0.009) {
          value = value + 0.01;
          campaingLeftOver -= 0.01;
        }
        baseBeneficiarys.push({
          ...baseBeneficiary,
          rewardValue: value.toString(),
          rewardType: 'Campanhas',
          locked: true
        });
      } else {
        value = otherRewardsValue;
        if (othersLeftOver > 0.009) {
          value = value + 0.01;
          othersLeftOver -= 0.01;
        }
        baseBeneficiarys.push({
          ...baseBeneficiary,
          rewardValue: value.toString()
        });
      }
    }
    return baseBeneficiarys;
  };

  const [beneficiarys, setBeneficiarys] = useState<RewardBeneficiary[]>(
    generateFirstBeneficiarys()
  );

  const updateBeneficiary = (index: number, beneficiary: RewardBeneficiary) => {
    const newBeneficiarys = JSON.parse(
      JSON.stringify(beneficiarys)
    ) as RewardBeneficiary[];
    newBeneficiarys[index] = beneficiary;
    setBeneficiarys(newBeneficiarys);
  };

  const [dataConfirmed, setDataConfirmed] = useState(false);
  const getTitleText = () => {
    if (dataConfirmed) {
      return 'Confira os dados para confirmar o resgate';
    } else {
      return 'Preencha as informações do beneficiário';
    }
  };
  const containerRef = useRef<HTMLDivElement>(null);
  window.onscroll = () => {
    myScroll();
  };
  const containerRef2 = useRef<HTMLDivElement>(null);
  window.onscroll = () => {
    myScroll();
  };

  const stick = containerRef2.current?.offsetTop
    ? containerRef2.current?.offsetTop
    : 0;

  const myScroll = () => {
    if (window.scrollY > stick) {
      containerRef.current?.classList.add('right-items-fixed');
      containerRef.current?.classList.remove('right-items');
    } else {
      containerRef.current?.classList.add('right-items');
      containerRef.current?.classList.remove('right-items-fixed');
    }
  };
  return (
    <div className="container" ref={containerRef2}>
      <Container>
        <div className="left-items">
          <div className="left-title">
            <Title level={3}>{getTitleText()}</Title>
          </div>

          <div className="line">
            <hr />
          </div>

          {!dataConfirmed &&
            beneficiarys.map((beneficiary, index) => (
              <div>
                <Form
                  beneficiary={beneficiary}
                  onChangeBeneficiaryData={(beneficiaryData) =>
                    updateBeneficiary(index, beneficiaryData)
                  }
                  index={index + 1}
                ></Form>
              </div>
            ))}
          {dataConfirmed &&
            beneficiarys.map((beneficiary, index) => (
              <div>
                <FormConfirmed
                  beneficiary={beneficiary}
                  index={index + 1}
                  setDataConfirmed={() => setDataConfirmed(false)}
                ></FormConfirmed>
              </div>
            ))}
        </div>
        <div className="right-items" ref={containerRef}>
          <div className="left-title">
            <Title level={3}>Saldo de pontos</Title>
          </div>

          <div className="line">
            <hr />
          </div>

          <CoinTotals
            beneficiaries={beneficiarys}
            dataConfirmed={dataConfirmed}
            setDataConfirmed={(isDataConfirmed: boolean) =>
              setDataConfirmed(isDataConfirmed)
            }
            setSuccess={(success) => setSuccess(success)}
          ></CoinTotals>
        </div>
      </Container>
    </div>
  );
};

export default RewardForm;
